export const CHART_COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
] as const;

// Tailwind only emits utilities found verbatim in source.
export const CHART_BG_CLASSES = [
  "bg-(--chart-1)",
  "bg-(--chart-2)",
  "bg-(--chart-3)",
  "bg-(--chart-4)",
  "bg-(--chart-5)",
] as const;

const wrapIndex = (index: number, length: number): number =>
  ((index % length) + length) % length;

export const chartSeriesColor = (index: number): string =>
  CHART_COLORS[wrapIndex(index, CHART_COLORS.length)];

export const chartSeriesBgClass = (index: number): string =>
  CHART_BG_CLASSES[wrapIndex(index, CHART_BG_CLASSES.length)];

// Index 0 is darkest (stack bottom).
export const BUNDLE_PURPLE_BG_CLASSES = [
  "bg-purple-800",
  "bg-purple-600",
  "bg-purple-400",
  "bg-purple-300",
  "bg-purple-200",
] as const;

const BUNDLE_PURPLE_COLORS = [
  "var(--color-purple-800)",
  "var(--color-purple-600)",
  "var(--color-purple-400)",
  "var(--color-purple-300)",
  "var(--color-purple-200)",
] as const;

const clampBundleIndex = (index: number, length: number): number =>
  Math.min(Math.max(0, index), length - 1);

export const bundleFormatColor = (index: number): string =>
  BUNDLE_PURPLE_COLORS[clampBundleIndex(index, BUNDLE_PURPLE_COLORS.length)];

export const bundleFormatBgClass = (index: number): string =>
  BUNDLE_PURPLE_BG_CLASSES[
    clampBundleIndex(index, BUNDLE_PURPLE_BG_CLASSES.length)
  ];
